<template>
  <div>
    <card>
      <div slot="header">
        <h4 class="card-title">Role List</h4>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <router-link
            :to="{ name: 'Create Role' }"
            :disabled="!hasRole('create')"
            class="btn pull-right btn-border"
            >ADD ROLE</router-link
          >
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table
            v-loading="loading"
            :data="roles"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              min-width="150"
              prop="name"
              label="Name"
            ></el-table-column>
            <el-table-column
              min-width="200"
              prop="module"
              label="Module"
            ></el-table-column>
            <el-table-column
              min-width="150"
              prop="access"
              label="Access"
            ></el-table-column>
            <el-table-column
              min-width="100"
              prop="users"
              label="Users"
              align="center"
            ></el-table-column>
            <el-table-column
              min-width="150"
              header-align="right"
              label="Actions"
            >
              <template slot-scope="scope">
                <div class="text-right table-actions">
                  <el-tooltip content="Edit" :open-delay="300" placement="top">
                    <n-button
                      @click.native="editRole(scope.row)"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="now-ui-icons ui-2_settings-90"></i>
                    </n-button>
                  </el-tooltip>

                  <el-tooltip
                    content="Delete"
                    :open-delay="300"
                    placement="top"
                  >
                    <n-button
                      @click.native="confirmDeleteRole(scope.row)"
                      type="danger"
                      size="sm"
                      icon
                      :disabled="!hasRole('delete')"
                    >
                      <i class="now-ui-icons ui-1_simple-remove"></i>
                    </n-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pull-right py-3">
        <n-pagination
          type="info"
          :pageCount="pagination.totalPages"
          :perPage="pagination.perPage"
          v-model="currentPage"
          @input="changePage"
        ></n-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Table, TableColumn, MessageBox, Loading } from "element-ui";
import { Pagination } from "src/components";
import { findUserRole, userRolesCheck } from "@/util/userRoles";
import Helper from "@/util/helper";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  created: function () {
    userRolesCheck("read", "role");
    this.getRoles({ page: 1 })
      .then((response) => {
        this.loading = false;
        this.currentPage = this.pagination.currentPage;
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      currentPage: 0,
    };
  },
  computed: {
    ...mapState("roles", ["roles", "pagination"]),
  },
  methods: {
    ...mapActions("roles", ["getRoles", "deleteRole"]),
    hasRole(role) {
      return findUserRole(role, "role");
    },
    editRole(role) {
      this.$router.push({
        name: "Edit Role",
        params: { id: role.id, slug: Helper.convertToSlug(role.name) }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.loading = true;
      this.getRoles({ page })
        .then((response) => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    confirmDeleteRole(role) {
      MessageBox.confirm(
        `This will permanently delete role "${role.name}". Continue?`,
        "Confirmation",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          let loadingInstance = Loading.service({
            fullscreen: true,
          });
          this.deleteRole(role)
            .then((response) => {
              loadingInstance.close();
              this.$notify({
                message: "Delete role success",
                timeout: 5000,
                icon: "now-ui-icons ui-1_bell-53",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
              });
            })
            .catch((error) => {
              loadingInstance.close();
              this.$notify({
                message: "Delete role failed",
                timeout: 5000,
                icon: "now-ui-icons ui-1_bell-53",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger",
              });
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.merge) {
          return {
            rowspan: row.merge,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else if (columnIndex === 3) {
        if (row.merge) {
          return {
            rowspan: row.merge,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else if (columnIndex === 4) {
        if (row.merge) {
          return {
            rowspan: row.merge,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.checkbox-cell {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-table thead {
  color: #000000 !important;
}
</style>
